/* AW - Tímarit — dependency-free magazine viewer. Additive; not part of theme.js. */
(function () {
  'use strict';

  function init(root) {
    if (root.hasAttribute('data-timarit-ready')) return;
    root.setAttribute('data-timarit-ready', '');

    var track = root.querySelector('[data-timarit-track]');
    if (!track) return;

    var pages = [].slice.call(track.querySelectorAll('.timarit__page'));
    if (!pages.length) return;

    var prev = root.querySelector('[data-timarit-prev]');
    var next = root.querySelector('[data-timarit-next]');
    var counter = root.querySelector('[data-timarit-counter]');
    var label = root.getAttribute('data-page-label') || '';
    var total = pages.length;
    var view = 0;
    var programmatic = false;
    var progTimer = null;

    var coverAlone = root.hasAttribute('data-cover-alone');

    function isWide() {
      return window.matchMedia('(min-width: 900px)').matches;
    }

    // Desktop shows two pages per view; with a cover page the cover takes a
    // whole view on its own, so pairing shifts to 2-3, 4-5, ...
    function viewCount() {
      if (!isWide()) return total;
      if (coverAlone) return 1 + Math.ceil((total - 1) / 2);
      return Math.ceil(total / 2);
    }

    function pagesInView(v) {
      if (!isWide()) return [v + 1, v + 1];
      if (coverAlone) {
        if (v <= 0) return [1, 1];
        var f = 2 + (v - 1) * 2;
        return [Math.min(f, total), Math.min(f + 1, total)];
      }
      var g = v * 2 + 1;
      return [Math.min(g, total), Math.min(g + 1, total)];
    }

    function sync() {
      var r = pagesInView(view);
      if (counter) {
        var range = r[1] > r[0] ? r[0] + '\u2013' + r[1] : String(r[0]);
        counter.textContent = (label ? label + ' ' : '') + range + ' / ' + total;
      }
      if (prev) prev.disabled = view <= 0;
      if (next) next.disabled = view >= viewCount() - 1;
    }

    // Scroll to an exact view boundary. Relative scrollBy fights
    // `scroll-snap-type: mandatory`, which silently drops or reverses steps.
    function go(v) {
      view = Math.max(0, Math.min(viewCount() - 1, v));
      // Guard the settle handler: it would otherwise read a scrollLeft that the
      // smooth animation has not moved yet and snap `view` back.
      programmatic = true;
      clearTimeout(progTimer);
      progTimer = setTimeout(function () { programmatic = false; }, 700);
      track.scrollTo({ left: view * track.clientWidth, behavior: 'smooth' });
      sync();
    }

    function step(dir) { go(view + dir); }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Keep the view in step with manual swipes, once scrolling has settled.
    var settleTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (programmatic) return;
        view = Math.round(track.scrollLeft / (track.clientWidth || 1));
        sync();
      }, 120);
    }, { passive: true });

    window.addEventListener('resize', function () {
      view = Math.round(track.scrollLeft / (track.clientWidth || 1));
      sync();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });

    // Zoom overlay — the only way A4 body text is readable on a phone.
    var zoom = root.querySelector('[data-timarit-zoom]');
    if (zoom) {
      var zoomImg = zoom.querySelector('img');
      var closeBtn = zoom.querySelector('[data-timarit-zoom-close]');
      var lastFocus = null;

      var openZoom = function (src, alt) {
        lastFocus = document.activeElement;
        zoomImg.src = src;
        zoomImg.alt = alt || '';
        zoom.classList.add('is-open');
        zoom.scrollTop = 0;
        document.documentElement.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      };

      var closeZoom = function () {
        zoom.classList.remove('is-open');
        zoomImg.removeAttribute('src');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      };

      pages.forEach(function (page) {
        page.addEventListener('click', function () {
          var img = page.querySelector('img');
          if (img) openZoom(img.currentSrc || img.src, img.alt);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', closeZoom);
      zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && zoom.classList.contains('is-open')) closeZoom();
      });
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-timarit]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
